import React from 'react';
import { useEffect, useState, useContext } from 'react';
import './form.css';
// import InputMask from 'react-input-mask';
import * as $ from 'jquery';
import 'jquery-mask-plugin/dist/jquery.mask.min'; 
// import validator from 'validator';

import Button from '../buttons/buttons';
import MyContext from '../../globalState/globalState'

import apiUF from '../../api/apiUF';
import apiCEP from '../../api/apiCEP';
import api from '../../api/api';

import ErrosJson from './../../config-erros.json';
// import { getValue } from '@testing-library/user-event/dist/utils';

import Cookies from 'universal-cookie';

import { cpf, cnpj } from '../../funcoes';

const Popup = (props) => {
    const[user, setUser] = useState([]);
    const[cnae, setCnae] = useState([]);
    const[changeUser, setChangeUser] = useState(false);
    const[newUser, setNewUser] = useState(true);
    // const[response, setResponse] = useState();
    // const[idCliente, setIdCliente] = useState();
    const[hiddenDoc, setHiddenDoc] = useState(true);
    const[hiddenICMS, setHiddenICMS] = useState(true);
    const[hiddenForm, setHiddenForm] = useState(true);  
    const[hiddenCep, setHiddenCep] = useState(true);
    // const[formFinish, setFormFinish] = useState(false);
    const[clientReadOnly, setClientReadOnly] = useState(true);
    const[docBeneficiadoReadOnly, setDocBeneficiadoReadOnly] = useState(true);
    const[documentReadOnly, setDocumentReadOnly] = useState(true);
    const[progressBar, setProgressBar] = useState(0);
    const[progressBarText1, setProgressBarText1] = useState(0);
    const[progressBarText2, setProgressBarText2] = useState(0);
    const[validatedFields, setValidatedFields] = useState(false);
    let validFields = false;
    let cnaeFormatado = [];
    // const[fields, setFields] = useState([]);
    const[hiddenWarring, setHiddenWarring] = useState(false);
    const[hiddenWarringDocumento, sethiddenWarringDocumento] = useState(false);

    const accessTokenGS = useContext(MyContext);
    // console.log(accessTokenGS);
    const [login, setLogin] = useState('')
    const cookies = new Cookies();

    let documento_beneficiario;
    let tipo_documento_beneficiario;

    const [labelDocB, setLabelDocB] = useState()
    const [tipoDocB, setTipoDocB] = useState()
    const [tipoDoc, setTipoDoc] = useState()


    const idsPF = [5, 6, 13, 16, 19];
    const idsPJ = [22, 23, 26, 29, 32, 35, 36, 37, 38];

    const [showDocError, setShowDocError] = useState(false)
    const [docErrorMessage, setDocErrorMessage] = useState('')

    const [showDocBError, setShowDocBError] = useState(false)
    const [docBErrorMessage, setDocBErrorMessage] = useState('')




    const[uf, setUf] = useState([]);
    useEffect(() =>{

        verificaTipoProduto();

            getSessionParams();
        apiUF.get('estados/')
            .then((response)=>{
                setUf(response.data);
                // console.log(response.data)
            });
        // api.get('ws_cnae/', 
        //     {headers: {"Authorization": `Bearer ${login}`}}
        //     ).then((response) => {
        //         setCnae(response);
        //         //inserir tudo em um array
        //         let cnaeNFormatado = response.data.detalhe[0];
                
        //         cnaeNFormatado.map((response) => {
        //             // response.map((response2) => {
        //                 if(cnaeFormatado.length < (cnaeNFormatado.length)){
        //                     cnaeFormatado.push(response);
        //                 }
        //             // })
        //         })
        //         setCnae(cnaeFormatado);
        //     })
        idFields();
        $(function(){
            $("#tCelular").mask('(00) 00000-0000');
            $("#tFixo").mask('(00) 0000-0000');
            $("#cep").mask('00.000-000');
        });
        // document.querySelector('input[name="ICMS"]').checked ;
    }, []);
    //sessionVar
    async function getSessionParams(){
        let session = accessTokenGS.accessTokenGS;
        setLogin(accessTokenGS.accessTokenGS)
    }
    const idFields = () => {

    }
    //emptying fields
    const drainFields = () => {
        try{
            let resposta = "Deseja apagar todos os dados?";
            if((document.getElementById('nome').value !== undefined) && (document.getElementById('nome').value !== '' || document.getElementById('nome').value.length !== 0 )){
                if(window.confirm(resposta) === true){
                    document.getElementById('idcliente').value = "";
                    document.getElementById('nome').value = "";
                    document.getElementById('tCelular').value = "";
                    document.getElementById('tFixo').value = "";
                    document.getElementById('ePrincipal').value = "";
                    document.getElementById('eFinanceiro').value = "";
                    document.getElementById('cep').value = "";
                    document.getElementById('endereco').value = "";
                    document.getElementById('numero').value = "";
                    document.getElementById('complemento').value = "";
                    document.getElementById('bairro').value = "";
                    document.getElementById('cidade').value = "";
                    document.getElementById('UF').value = "";
                    if(document.querySelector('input[name="PFPJ"]:checked').value === "J"){
                        document.getElementById('nomeFantasia').value = "";
                        // document.getElementById('N').disabled = false;
                        // document.getElementById('S').disabled = false;
                        // document.getElementById('cnae').value = 0;
                        // if(document.querySelector('input[name="ICMS"]:checked').value === "S"){
                        //     document.getElementById('N').checked = true;
                        // }
                    }
                }
            }
        }catch(error){
            console.log(error);
        }
           //implementar cnpj
    }
    function EFin(){
        let ePrincipalEmail = document.getElementById('ePrincipal').value;
        let eFinanceiroEmail = document.getElementById('eFinanceiro').value;
        if(eFinanceiroEmail === undefined || eFinanceiroEmail === ''){
            setTimeout(() => document.getElementById('eFinanceiro').value = ePrincipalEmail, 3000)
            //document.getElementById('eFinanceiro').value = await ePrincipalEmail;
        }
    }
    //submitting form
    const submit = () => {

        //impede a requisição caso o documento seja inválido
        if(showDocError || showDocBError){
            return;
        }

       try {

        sethiddenWarringDocumento(s => false)
        validateFields();
        if(validatedFields || validFields){
            
            //implementar 3 cenários - 
            //1 - cliente atualizado e com contrato
            //2 - cliente atualizdo sem contrato
            //3 - cliente sem usuário e sem contrato

            documento_beneficiario = formatString(document.getElementById('documento_beneficiario').value);

            EFin();
            if((newUser === false) && (changeUser === false)){
                let data = {
                    clien_inid_cliente: parseInt(document.getElementById('idcliente').value),
                    clien_dmtp_documento: document.querySelector('input[name="PFPJ"]:checked').value,
                    clien_binu_documento: formatString(document.getElementById('documento').value),
                    clien_vcnm_razaosocial: document.getElementById('nome').value,
                    clien_vcds_endereco: document.getElementById('endereco').value,
                    clien_vcnu_numero: document.getElementById('numero').value !== '' && document.getElementById('numero').value !== 0 ? document.getElementById('numero').value : 1 ,
                    clien_vcds_complemento: document.getElementById('complemento').value,
                    clien_vcnm_bairro: document.getElementById('bairro').value,
                    clien_vcnm_cidade: document.getElementById('cidade').value,
                    clien_chcd_uf: document.getElementById('UF').value,
                    clien_chcd_cep: formatString(document.getElementById('cep').value),
                    clien_bite_fixo: formatString(document.getElementById('tFixo').value),
                    clien_bite_celular: formatString(document.getElementById('tCelular').value),
                    clien_bite_whatsapp: formatString(document.getElementById('tCelular').value),
                    clien_vcem_principal: document.getElementById('ePrincipal').value ,
                    clien_vcem_financeiro: document.getElementById('eFinanceiro').value
                }
                buyCertificate(data);
            }else if((newUser === false) && (changeUser === true)){
    
            }else if((newUser === true)){
                let data;
                if(document.querySelector('input[name="PFPJ"]:checked').value === "F"){
                    data = {
                        //alerta dados fixos
                        // "clien_inid_cliente": 0,
                        // "ctcon_inid_carteiracontrato": 6,
                        // "conrc_inid_contratorepresentantecomercial": 4,
                        // "tpref_inid_tabelaprecoreferencia": 12,

                        clien_dmtp_documento: document.querySelector('input[name="PFPJ"]:checked').value,
                        clien_binu_documento: formatString(document.getElementById('documento').value),
                        clien_vcnm_razaosocial: document.getElementById('nome').value,
                        clien_vcds_endereco: document.getElementById('endereco').value,
                        clien_vcnu_numero: document.getElementById('numero').value !== '' && document.getElementById('numero').value !== '0' ? document.getElementById('numero').value : 1 ,
                        clien_vcds_complemento: document.getElementById('complemento').value,
                        clien_vcnm_bairro: document.getElementById('bairro').value,
                        clien_vcnm_cidade: document.getElementById('cidade').value,
                        clien_chcd_uf: document.getElementById('UF').value,
                        clien_chcd_cep: formatString(document.getElementById('cep').value),
                        clien_bite_fixo: formatString(document.getElementById('tFixo').value),
                        clien_bite_celular: formatString(document.getElementById('tCelular').value),
                        clien_bite_whatsapp: formatString(document.getElementById('tCelular').value),
                        clien_vcem_principal: document.getElementById('ePrincipal').value,
                        clien_vcem_financeiro: document.getElementById('eFinanceiro').value
                    }
                }else if(document.querySelector('input[name="PFPJ"]:checked').value === "J"){
                    let numICMS = 0;
                    // if(document.querySelector('input[name="ICMS"]:checked').value === "S"){
                    //     // numICMS = document.getElementById('numeroICMS').value;
                    //     numICMS = 0;
                    // }
                    data = {
                        // "clien_inid_cliente": 0,
                        // "ctcon_inid_carteiracontrato": 6,
                        // "conrc_inid_contratorepresentantecomercial": 4,
                        // "tpref_inid_tabelaprecoreferencia": 12,
    
                        clien_dmtp_documento: document.querySelector('input[name="PFPJ"]:checked').value,
                        clien_binu_documento: formatString(document.getElementById('documento').value),
                        clien_vcnm_razaosocial: document.getElementById('nome').value,
                        clien_vcnm_fantasia: document.getElementById('nomeFantasia').value,
                        clien_vcnu_inscricaoestadual: numICMS,
                        // cnae: document.querySelector('input[name="ICMS"]:checked').value,
                        // cnae_vccd_cnae: formatString(document.getElementById('cnae').value),
                        // cnae_vccd_cnae: document.getElementById('cnae').value,
                        // cnae: formatString(document.getElementById('cnae').value),
                        clien_vcds_endereco: document.getElementById('endereco').value,
                        clien_vcnu_numero: document.getElementById('numero').value !== '' && document.getElementById('numero').value !== '0' ? document.getElementById('numero').value : 1 ,
                        clien_vcds_complemento: document.getElementById('complemento').value,
                        clien_vcnm_bairro: document.getElementById('bairro').value,
                        clien_vcnm_cidade: document.getElementById('cidade').value,
                        clien_chcd_uf: document.getElementById('UF').value,
                        clien_chcd_cep: formatString(document.getElementById('cep').value),
                        clien_bite_fixo: formatString(document.getElementById('tFixo').value),
                        clien_bite_celular: formatString(document.getElementById('tCelular').value),
                        clien_bite_whatsapp: formatString(document.getElementById('tCelular').value),
                        clien_vcem_principal: document.getElementById('ePrincipal').value,
                        clien_vcem_financeiro: document.getElementById('eFinanceiro').value
                    }
                }
                newClient(data);
            }
        }
        // console.log('Formulário enviado!');
       } catch (error) {
            console.log(error)
       }
    }
    const newClient = (data) => {
        try {
            api.post('ws_contratocliente/', data,
            { headers: {Authorization: `Bearer ${login}`} }
                ).then((response) => {
                    if(response.data.status === 0 || response.status === 201){
                        buyCertificate(data);
                    }else{
                        validateFields();
                        let erro = ErrosJson.find(
                            (config) => config.codigo === response.data.status.codigo
                        );
                        console.log(erro)
                        
                        alert("confira os dados!");
                    }
                }).catch((error) => {
                    if(error.toJSON().status === 401){
                        console.log("Não autorizado! - post");
                        console.log(error);
                    }else{
                        console.log(error)
                        if(error.response.data.indexOf('</HTML>')){
                            let erroStr = error.response.data.substring(error.response.data.indexOf('</HTML>') + 7);
                            let erroStrFormatado = JSON.parse(erroStr);
                            // if(erroStrFormatado.status.mensagem.indexOf('estadual')){
                            //     document.getElementById('numeroICMS').className = "form-control empty";
                            // }
                            alert(erroStrFormatado.status.mensagem);
                            console.log(erroStrFormatado);
                        }
                    }
                })
        } catch (error) {
            
        }
    }
    const buyCertificate = (data) => {
        try {
            let idClientCertificate = 0;
            setHiddenForm(s => false);
            document.getElementById('box-form').className = "box form-input";
            setProgressBarText1( 'Aguarde.' );
            setProgressBarText2( 'O seu pedido está sendo processado...' );
            setProgressBar(25);
            setTimeout(() => {
                api.get('ws_cliente/',
                {   
                    headers: { Authorization : `Bearer ${login}` }, 
                    params: {
                        clien_dmtp_documento: data.clien_dmtp_documento,
                        clien_binu_documento: parseInt(data.clien_binu_documento)
                    }}
                ).then((response) => {
                    idClientCertificate = parseInt(response.data.detalhe[0].clien_inid_cliente);
                    searchContract(idClientCertificate, data.clien_dmtp_documento, data);
                });
            }, 2000);
        } catch (error) {
            
        }
        
    }
    function searchClient (){
        try {
            let tpDocumento = "";
            const documento = formatString(document.getElementById('documento').value);
            if(documento.length < 12){
                tpDocumento = "F";
            }else{
                tpDocumento = "J";
            }
            //tratar cpfs ou cnpj válidos
            api.get('ws_cliente/',
                {   
                    headers: {"Authorization" : `Bearer ${login}`}, 
                    params: {
                    clien_dmtp_documento: tpDocumento,
                    clien_binu_documento: documento
                }}
                ).then((response) => {
                    setDocBeneficiadoReadOnly(s => false)
                    // console.log(response.data.detalhe[0]);
                    if(response.data.detalhe[0]){
                        setUser(response.data.detalhe);
                        setNewUser(false);
                        setChangeUser(false);
                        let idCliente = response.data.detalhe[0].clien_inid_cliente;
                        setClientReadOnly(s => true);
                        setDocBeneficiadoReadOnly(s => false);
                        let tpDocumento = response.data.detalhe[0].clien_dmtp_documento;
                        let nome = response.data.detalhe[0].clien_vcnm_razaosocial;
                        let telefone = response.data.detalhe[0].clien_bite_celular;
                        let fixo = response.data.detalhe[0].clien_bite_fixo;
                        let email = response.data.detalhe[0].clien_vcem_principal;
                        let financeiro = response.data.detalhe[0].clien_vcem_financeiro;
                        let cep = response.data.detalhe[0].clien_chcd_cep;
                        let endereco = response.data.detalhe[0].clien_vcds_endereco;
                        let numero = response.data.detalhe[0].clien_vcnu_numero;
                        let complemento = response.data.detalhe[0].clien_vcds_complemento;
                        let bairro = response.data.detalhe[0].clien_vcnm_bairro;
                        let cidade = response.data.detalhe[0].clien_vcnm_cidade;
                        let UF = response.data.detalhe[0].clien_chcd_uf;
                        document.getElementById('idcliente').value = idCliente;
                        document.getElementById('nome').value = nome;
                        if(tpDocumento === "F"){
                            document.getElementById('PF').checked = true;
                        }else{
                            document.getElementById('PJ').checked = true;
                            document.getElementById('nomeFantasia').value = response.data.detalhe[0].clien_vcnm_fantasia;
                        }
                        document.getElementById('tCelular').value = telefone;
                        document.getElementById('tFixo').value = fixo;
                        document.getElementById('ePrincipal').value = email;
                        document.getElementById('cep').value = cep;
                        document.getElementById('endereco').value = endereco;
                        document.getElementById('numero').value = numero;
                        document.getElementById('complemento').value = complemento;
                        document.getElementById('bairro').value = bairro;
                        document.getElementById('cidade').value = cidade;
                        document.getElementById('UF').value = UF;
                        document.getElementById('eFinanceiro').value = financeiro;
                    }else{
                        //limpar formulário e valores
                        setUser([]);
                        setChangeUser(false);
                        setNewUser(true);
                        setDocBeneficiadoReadOnly(s => false);
                        setClientReadOnly(s => false);
                        // docBeneficiadoReadOnly(s => false);
                        drainFields();
                    }
                }).catch(function (error) {
                    //limpar formulário e valores
                    setUser([]);
                    setChangeUser(false);
                    setNewUser(true);
                    // setResponse('');
                    // setIdCliente('');
                    //if(error.response.status === 404){
                        setClientReadOnly(false)
                        setDocBeneficiadoReadOnly(s => false);
                        drainFields();
                    //}else if(error.response.status === 401){
                        console.log("não autorizado!");
                        // console.log(error);
                    //}
                });

            if(user){
                setNewUser(true);
            }
        } catch (error) {
            
        }
    }
    function searchContract (idClientCertificate, documento, userData){
        try {
            //busca contrato cliente
            setProgressBar(50);
            let idContractClient = 0;
            setTimeout(() => {
                api.get('ws_contratocliente/',
                    {   
                        headers: { Authorization : `Bearer ${login}` }, 
                        params: {
                            clien_inid_cliente: idClientCertificate,
                            clien_dmtp_documento: documento
                        }}
                ).then((response) => {
                    idContractClient = parseInt(response.data.detalhe[0].concl_inid_contratocliente);
                    paymentSlip(idContractClient);
                }).catch((error) =>{
                    console.log(error.response);
                    // if(error.response.status === 404){
                        console.log(idClientCertificate, documento, userData)
                        newContract(idClientCertificate, documento, userData);
                    // }
                });
            }, 3000);
        } catch (error) {
            
        } 
    }
    function newContract(idContractClient, documento, userData){
        let carteiracontrato;
        let contratorepresentante;
        let tabelaprecoreferencia;
        if(userData.ctcon_inid_carteiracontrato === undefined || userData.ctcon_inid_carteiracontrato === null){
            carteiracontrato = userData.ctcon_inid_carteiracontrato;
        }else{
            carteiracontrato = 6;
        }
        if(userData.conrc_inid_contratorepresentantecomercial === undefined || userData.conrc_inid_contratorepresentantecomercial === null){
            contratorepresentante = userData.conrc_inid_contratorepresentantecomercial;
        }else{
            contratorepresentante = 4;
        }
        if(userData.tpref_inid_tabelaprecoreferencia === undefined || userData.tpref_inid_tabelaprecoreferencia === null){
            tabelaprecoreferencia = userData.tpref_inid_tabelaprecoreferencia;
        }else{
            tabelaprecoreferencia = 12;
        }
        let data = {
            "clien_binu_documento": documento,
            "clien_inid_cliente": idContractClient,
            "ctcon_inid_carteiracontrato": 6,
            "conrc_inid_contratorepresentantecomercial": 4,
            "tpref_inid_tabelaprecoreferencia": 12,
        }
        api.post('ws_contratocliente/', data,
            { headers: {Authorization: `Bearer ${login}`} }
            ).then((response) => {
                // setResponse(response.data);
                searchContract(response.data.concl_inid_contratocliente ,response.data.clien_inid_cliente, response.data.clien_dmtp_documento, response.data);
            }).catch((error) => {
                console.log(error);
                if(error.toJSON().status === 401){
                    console.log("Não autorizado! - post");
                }
            })
    }
    //payment
    const paymentSlip = (idContractClient) => {
        setProgressBar(63);
        // post produto
        setTimeout(() => {
            /**
            * Dados a serem enviados para o pagamento 
            *    console.log({concl_inid_contratocliente: idContractClient,
            *     detalhePedidoVenda: [
            *         {
            *             rubri_inid_rubricaproduto: parseInt(props.idCertificado),
            *             detpv_inqt_produto: 1,
            *             detpv_dmtp_documentobeneficiario: tipoDocB,
            *             detpv_binu_documentobeneficiario: documento_beneficiario
            *         }
            *     ]})
            * 
            * 
            */
            if(idContractClient !== 0){
                api.post('ws_pedidovenda/', {concl_inid_contratocliente: idContractClient,
                        detalhePedidoVenda: [
                            {
                                rubri_inid_rubricaproduto: parseInt(props.idCertificado),
                                detpv_inqt_produto: 1,
                                detpv_dmtp_documentobeneficiario: tipoDocB,
			                    detpv_binu_documentobeneficiario: documento_beneficiario
                            }
                        ]},{ headers: { Authorization: `Bearer ${login}`} },
                ).then((response) => {
                    if(response.data.status.codigo === -58){
                        console.log('cpf invalido')
                        setProgressBar(0);
                        setHiddenForm(s => true);
                        validFields = false;
                        sethiddenWarringDocumento(s => true)
                    }
                    salesOrder(parseInt(response.data.detalhe[0].pdven_inid_pedidovenda));
                }).catch((error) => {})
                
            }else{
                // console.log(dataBuyCertificate);
            }
        }, 3000);
    }
    const salesOrder = (orderId) => {
        setProgressBar(95);
        //alerta dados
        let dataPay = {
            "pdven_inid_pedidovenda": orderId,
            "ambiente": accessTokenGS.ambiente
        }
        //{{ambienteHermes}}
        api.post('ws_pagamentopedidovenda/',
                dataPay,{ headers: {Authorization: `Bearer ${login}`} }
            ).then((response) => {
                let urlCheckout = response.data.detalhe.urlCheckout;
                setTimeout(
                    function()
                    {
                        setProgressBarText1( 'Pedido registrado com sucesso.' );
                        setProgressBarText2( 'Realize o pagamento na tela seguinte ou clique no link que chegará no seu e-mail.' );
                        setProgressBar(100);
                    },
                    200
                );
                setTimeout(
                    function()
                    {
                        window.open(urlCheckout, "_self");
                    },
                    5000
                );
                //recarregar a tela
            }).catch((error) => {
                if(error.toJSON().status === 401){
                    console.log("Não autorizado! - post");
                }
            })
    }

    //switching fields
    const PFPJConfer = () => {
        //Conferir se é pf ou pj
        setDocumentReadOnly(s => false);
        if(document.querySelector('input[name="PFPJ"]:checked').value === "F"){
            setTipoDoc(s => 'F')
            setHiddenDoc(s => true)
            document.getElementById('documento').maxLength = "11";
            document.getElementById('documento').disabled = false
            $(function(){
                $("#documento").mask('000.000.000-00');
            });
            let maskInput = "xxx.xxx.xxx-xx";
            if(document.getElementById('documento').length > 11){
                document.getElementById('documento').value = "";
            }
        }else{
            setTipoDoc(s => 'J')
            setHiddenDoc(s => false)
            document.getElementById('documento').maxLength = "18";
            document.getElementById('documento').disabled = false
            $(function(){
                $("#documento").mask('00.000.000/0000-00');
            });
        }
    }

    const PFPJBConfer = () => {
        //Conferir se é pf ou pj
        if(tipo_documento_beneficiario === "F"){
            document.getElementById('documento_beneficiario').maxLength = "11";
            document.getElementById('documento_beneficiario').disabled = false
            $(function(){
                $("#documento_beneficiario").mask('000.000.000-00');
            });
            let maskInput = "xxx.xxx.xxx-xx";
            if(document.getElementById('documento_beneficiario').length > 11){
                document.getElementById('documento_beneficiario').value = "";
            }
        }else{
            document.getElementById('documento_beneficiario').maxLength = "18";
            document.getElementById('documento_beneficiario').disabled = false
            $(function(){
                $("#documento_beneficiario").mask('00.000.000/0000-00');
            });
        }
    }

    const ICMS = () => {
        if(document.querySelector('input[name="ICMS"]:checked').value === "S"){
            setHiddenICMS(s => false);
        }else if(document.querySelector('input[name="ICMS"]:checked').value === "N"){
            setHiddenICMS(s => true);
        }
    }
    //form validations
    const validaEmail = (value) => {
        EFin();
    }
    const validaPhone = (value, showAlert) => {
        let phoneUnformated = document.getElementById(`${value}`).value;
        let tCelular = phoneUnformated.replace(/[^0-9]/g, '');       
        if(tCelular.length === 11){
            document.getElementById(`${value}`).className = "form-control";
            return true
        }else{
            document.getElementById(`${value}`).className = "form-control empty";
            if(showAlert){
                alert('Confira o telefone!');
            }
            return false
        }
    }
    const searchCEP = () => {
        apiCEP.get('cep/'+formatString(document.getElementById('cep').value)+'.json',
        ).then((response) => {
            if(response.data.status === 200){
                let logradouro = response.data;
                document.getElementById('endereco').value = logradouro.address;
                document.getElementById('bairro').value = logradouro.district;
                document.getElementById('cidade').value = logradouro.city;
                document.getElementById('UF').value = logradouro.state;
                setHiddenCep(true);
            }else if(response.data.status === 404){
                // validar de acordo com o erro
                document.getElementById('endereco').value = "";
                document.getElementById('bairro').value = "";
                document.getElementById('cidade').value = "";
                document.getElementById('UF').value = "0";
                setHiddenCep(false);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    // const searchDoc = (documento) => {
    //     //console.log(documento);
    //     //alert(documento);
    // }
    //campos obrigatórios
    const validateFields = () => {
        let fieldsO = [];
        if(document.querySelector('input[name="PFPJ"]:checked').value === "F"){
            fieldsO = ['documento', 'nome','tCelular', 'ePrincipal', 'documento_beneficiario', 'cep','endereco','numero', 'bairro', 'cidade', 'UF'];
        }else if(document.querySelector('input[name="PFPJ"]:checked').value === "J"){
            fieldsO = ['documento', 'nome', 'nomeFantasia','tCelular', 'ePrincipal', 'documento_beneficiario', 'cep','endereco','numero', 'bairro', 'cidade', 'UF'];
        }
        let errorFields = [];
        fieldsO.map((response) => {
            let elem = document.getElementById(response);
            if(elem?.value){
                document.getElementById(response).className = "form-control"; 
                if(response === "tCelular"){
                    if(!validaPhone(response, false)){
                        errorFields.push(response);
                    }
                }
            }else{
                errorFields.push(response);
            }
        });
        if(errorFields.length > 0){
            setHiddenWarring(true);
            setValidatedFields(false);
            validFields = false;
        }else{
            setHiddenWarring(false);
            setValidatedFields(true);
            validFields = true;
        }
        errorFields.map((response) =>{
            document.getElementById(response).className = "form-control empty";
        })

    }
    //formatting data
    const formatString = (element) => {
        // let rem = ['.', ',', '(', ')', '-', ' '];
        let formated = element.replace(/[^0-9]/g, '') //^0-9 //-+()\s
        return formated;
    }
    const codErro = () =>{

    }

    const verificaTipoProduto = () => {

        if(idsPF.includes(props.idCertificado)){
            tipo_documento_beneficiario = "F"
            setTipoDocB(s => 'F')
            setLabelDocB(s => 'CPF vinculado ao Certificado Digital que será emitido.')
        } else if(idsPJ.includes(props.idCertificado)){
            // Mesmo para certificados PJ, o campo a ser preenchido aqui será sempre de um CPF
            tipo_documento_beneficiario = "F"
            setTipoDocB(s => 'F')
            setLabelDocB(s => 'CPF do sócio administrador da empresa.')
        } 

        PFPJBConfer();
    }

    const validateDoc = (field) => {
        let lengthDoc = tipoDoc === 'F' ? 11 : 14
        let doc = (field.target.value).replace(/\D/g, "");
        if(doc.length === lengthDoc){
            if(tipoDoc === 'F'){
                setDocFieldError(cpf.isValid(doc), tipoDoc)
            }else{
                setDocFieldError(cnpj.isValid(doc), tipoDoc)
            }
        }
    }

    const setDocFieldError = (valid, type) => {

        let doc = type === 'F' ? 'CPF' : 'CNPJ';
        if(!valid){
            document.getElementById('documento').className = "form-control empty";
            toggleDocErrorMessage(`${doc} inválido.`, true)
        } else {
            document.getElementById('documento').className = "form-control";
            toggleDocErrorMessage('', false)
        }
    }

    const toggleDocErrorMessage = (message, show) => {
        setShowDocError(s => show)
        setDocErrorMessage(s => message)
    }

    const validateDocB = (field) => {
        let lengthDoc = tipoDocB === 'F' ? 11 : 14
        let doc = (field.target.value).replace(/\D/g, "");
        if(doc.length === lengthDoc){
            if(tipoDocB === 'F'){
                setDocBFieldError(cpf.isValid(doc), tipoDocB)
            }else{
                setDocBFieldError(cnpj.isValid(doc), tipoDocB)
            }
        }
    }

    const setDocBFieldError = (valid, type) => {

        let doc = type === 'F' ? 'CPF' : 'CNPJ';
        if(!valid){
            document.getElementById('documento_beneficiario').className = "form-control empty";
            toggleDocBErrorMessage(`${doc} inválido.`, true)
        } else {
            document.getElementById('documento_beneficiario').className = "form-control";
            toggleDocBErrorMessage('', false)
        }
    }

    const toggleDocBErrorMessage = (message, show) => {
        setShowDocBError(s => show)
        setDocBErrorMessage(s => message)
    }

    return (
        <div className='popup-box'>
            
                 
                    <div className='box form-input' id='box-form' style={{display: hiddenForm ? 'block' : 'none' }}>
                        <button className='btn-close' onClick={props.HandleClose}></button>
                        <div className='box-form ' styles={{ height: '500px', overflowY: 'scroll' }}>
                            <h3 >{props.titulo}</h3>
                            <div className='row'>
                                <div className='col-md-6 box-info'>
                                    <div className='box-title'>
                                        <h4 className='title-form'>Dados do comprador</h4>
                                    </div>
                                    
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <input type='radio' value='F' name='PFPJ' id='PF' onClick={PFPJConfer}/> {/*onChange={changeUserConfer}*/}
                                                <label className="form-check-label title-label" htmlFor="exampleRadios2">
                                                    Pessoa Física
                                                </label>
                                            </div>
                                            
                                            <div className='col-md-6'>
                                                <input type='radio' value='J' name='PFPJ' id='PJ' onClick={PFPJConfer}/> {/*onChange={changeUserConfer}*/}
                                                <label className="form-check-label title-label" htmlFor="exampleRadios2">
                                                    Pessoa Jurídica
                                                </label>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-12'>
                                            <label className='title-label'>Documento<span className='text-danger'>*</span></label>
                                                    {/* <label htmlFor="exampleInputName1">Nome</label> */}
                                                <input type="hidden" className="form-control" id="idcliente" aria-describedby="idclientHelp" />
                                                {/* <input type="hidden" className="form-control" id="inscricaoEstadual" aria-describedby="idclientHelp" />
                                                <input type="hidden" className="form-control" id="cnae" aria-describedby="idclientHelp" /> */}
                                                <input type="text" className="form-control" required id="documento" aria-describedby="documentoHelp"  onBlur={() => searchClient()} readOnly={documentReadOnly} onKeyUp={validateDoc} /> {/*max={maxValue} disabled placeholder="CPF ou CNPJ*"*/}
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div className="form-group">
                                        <div className='row'>
                                        {hiddenDoc?
                                            <>
                                                <div className='col-md-12'>
                                                    <label className='title-label'>Nome<span className='text-danger'>*</span></label>
                                                    <input type="text" required readOnly={clientReadOnly} className="form-control" id="nome" aria-describedby="nameHelp" style={{ textTransform: 'uppercase'}}/> {/* onChange={changeUserConfer*/}
                                                </div>
                                            </>
                                        : 
                                            
                                            <>
                                            <div className='col-md-6'>
                                                <label className='title-label'>Nome<span className='text-danger'>*</span></label>
                                                <input type="text" required readOnly={clientReadOnly} className="form-control" id="nome" aria-describedby="nameHelp" style={{ textTransform: 'uppercase'}}/> {/* onChange={changeUserConfer*/}
                                            </div>
                                            <div className='col-md-6'>
                                                <label className='title-label'>Nome Fantasia<span className='text-danger'>*</span></label>
                                                <input type="text" readOnly={clientReadOnly} className="form-control" id="nomeFantasia" aria-describedby="nameHelp"  />
                                            </div>
                                        </>
                                        }                                         
                                        </div>   
                                    </div>
                                    
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                
                                            </div>
                                            <div className='col-md-6'>
                                            <label className='title-label'>Telefone Celular<span className='text-danger'>*</span></label>
                                            <input type="text" required readOnly={clientReadOnly} className="form-control" id="tCelular" aria-describedby="telHelp"  maxLength={'11'} onBlur={() => validaPhone('tCelular', true)} />
                                            </div><div className='col-md-6'>
                                            <label className='title-label'>Telefone Fixo</label>
                                            <input type="text"  readOnly={clientReadOnly} className="form-control" id="tFixo" aria-describedby="telHelp"  maxLength={'11'} />
                                            </div>
                                        </div>    
                                        
                                    </div>
                                    
                                    <div className="form-group">
                                        
                                        <div className='row'>
                                            <div className='col-md-6'>
                                            <label className='title-label'>E-mail<span className='text-danger'>*</span></label>
                                                <input type="email" required readOnly={clientReadOnly} className="form-control" id="ePrincipal" aria-describedby="emailHelp"  onBlur={() => validaEmail('ePrincipal')} />
                                            </div>
                                            <div className='col-md-6'>
                                            <label className='title-label'>E-mail (Financeiro)<span className='text-danger'>*</span></label>
                                                <input type="email" readOnly={clientReadOnly} className="form-control" id="eFinanceiro" aria-describedby="emailHelp" onBlur={() => validaEmail('eFinanceiro')}  />
                                            </div>
                                        </div>
                                        
                                    </div>
                                    {/* <span className='hint' title=" Informe aqui o documento de quem vai receber o Certificado Digital.">?</span> */}
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <label className='title-label' title="Atenção:  A emissão do seu Certificado Digital será feita necessariamente para o documento informado neste campo. Na tela de agendamento da emissão não será possível alterar esse documento.">{labelDocB}<span className='text-danger'>*</span></label>
                                                <input type="text" className="form-control" required id="documento_beneficiario" aria-describedby="documentoHelp" readOnly={docBeneficiadoReadOnly} onKeyUp={validateDocB} placeholder="Informe aqui o CPF que será usado do agendamento para emissão do Certificado Digital" title="Atenção: O agendamento da emissão do seu Certificado Digital será feito necessariamente com o CPF informado neste campo."/> {/*max={maxValue} disabled placeholder="CPF ou CNPJ*"*/}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="adjust"></div>


                                    
                                </div>
                                <div className='col-md-6 box-info'>
                                    <div className='box-title'>
                                        <h4 className='title-form'>Endereço do comprador</h4>
                                    </div>

                                    <div className="adjust"></div>

                                    <div className="form-group">
                                        <div className='row'>
                                            <label className='title-label'>CEP<span className='text-danger'>*</span></label>
                                            <div className='col-md-12'>
                                                <input type="text" required readOnly={clientReadOnly} className="form-control" id="cep" aria-describedby="cepHelp" maxLength={'8'} onBlur={searchCEP}/>
                                                {/* {!hiddenCep? 'Cep inválido!':''} */}
                                            </div>
                                        </div>    
                                    </div>

                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                 <label className='title-label'>Endereço<span className='text-danger'>*</span></label>
                                                <input type="text" required readOnly={clientReadOnly} className="form-control" id="endereco" aria-describedby="enderecoHelp" maxLength={'100'} />
                                            </div>
                                            <div className='col-md-6'>
                                                <label className='title-label'>Número<span className='text-danger'>*</span></label>
                                                <input type="text" required readOnly={clientReadOnly} className="form-control" id="numero" aria-describedby="numeroHelp" maxLength={'10'}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <label className='title-label'>Complemento</label>
                                                <input type="text" readOnly={clientReadOnly} className="form-control" id="complemento" aria-describedby="complementoHelp" maxLength={'100'} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <label className='title-label'>Bairro<span className='text-danger'>*</span></label>
                                                <input type="text" required readOnly={clientReadOnly} className="form-control" id="bairro" aria-describedby="bairroHelp" maxLength={'50'} />
                                            </div>
                                            <div className='col-md-6'>
                                                <label className='title-label'>Cidade<span className='text-danger'>*</span></label>
                                                <input type="text" required readOnly={clientReadOnly} className="form-control" id="cidade" aria-describedby="cidadeHelp" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <label className='title-label'>Estado<span className='text-danger'>*</span></label>
                                                <select className="form-control" required readOnly={clientReadOnly} id='UF' >
                                                    <option defaultValue={'0'}>Selecione</option>
                                                    {
                                                        uf.map((response)=>{
                                                            return <option value={response.sigla} key={response.id}>{response.nome}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row row-btn-submit'>
                                {hiddenWarring? <span className='text-danger'>Preencha os campos destacados</span>:null}
                                {hiddenWarringDocumento? <span className='text-danger'>Documento do beneficiário inválido</span>:null}
                                {showDocError? <span className='text-danger'>{docErrorMessage}</span>:null}
                                {showDocBError? <span className='text-danger'>{docBErrorMessage}</span>:null}
                                <Button btnSubmit click={submit.bind()} labelBtn='Enviar' function='submit'/>
                            </div>
                        </div> 
                    </div>   
                
                    
             
                {!hiddenForm ? 
                    <>
                        <div className='box progress-box form-input' id='box-form'>
                        <button className='btn-close' onClick={props.HandleClose}></button>
                            <div className='wait'>
                                <div className='bar-progress'>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h2>{progressBarText1}</h2>
                                            <h3>{progressBarText2}</h3>
                                        </div>
                                        <div className='col-md-12'>
                                            <progress id="file" value={progressBar} max="100"> {progressBar}% </progress>
                                        </div>
                                    </div>
                                    
                                    
                                    
                                </div>
                            </div>
                        </div>
                    </>
                    
                : null}
                        
        </div>
    )
}

export default Popup;